import { DefaultContext, EventObject, MachineConfig, StateSchema } from 'xstate/es';

import { FormPropertyShareStatechartEvent } from 'common/module/form/property-share/statechart.event';
import { FormPropertyShareStatechartActionEnum } from 'common/module/form/property-share/statechart/action.enum';
import { FormPropertyShareStatechartStateEnum } from 'common/module/form/property-share/statechart/state.enum';

export const FormPropertyShareStatechart: MachineConfig<DefaultContext, StateSchema, EventObject> = {
  initial: FormPropertyShareStatechartStateEnum.idle,
  states: {
    [FormPropertyShareStatechartStateEnum.idle]: {
      on: {
        [FormPropertyShareStatechartEvent.wantToSubmitForm]: FormPropertyShareStatechartStateEnum.validating,
      },
    },
    [FormPropertyShareStatechartStateEnum.validating]: {
      entry: [FormPropertyShareStatechartActionEnum.validateInput],
      on: {
        [FormPropertyShareStatechartEvent.inputIsValid]: FormPropertyShareStatechartStateEnum.submitting,
        [FormPropertyShareStatechartEvent.inputIsInvalid]: {
          target: [FormPropertyShareStatechartStateEnum.idle],
          actions: [FormPropertyShareStatechartActionEnum.resetSubmittingStatus],
        },
      },
    },
    [FormPropertyShareStatechartStateEnum.submitting]: {
      entry: [
        FormPropertyShareStatechartActionEnum.setSubmittingStatus,
        FormPropertyShareStatechartActionEnum.executeCaptcha,
      ],
      on: {
        [FormPropertyShareStatechartEvent.captchaValueChanged]: FormPropertyShareStatechartStateEnum.submitted,
      },
    },
    [FormPropertyShareStatechartStateEnum.submitted]: {
      entry: [FormPropertyShareStatechartActionEnum.sendSubmitRequest],
      on: {
        [FormPropertyShareStatechartEvent.submitSuccessful]: FormPropertyShareStatechartStateEnum.sent,
        [FormPropertyShareStatechartEvent.submitFailed]: {
          target: 'idle',
          actions: [
            FormPropertyShareStatechartActionEnum.resetSubmittingStatus,
            FormPropertyShareStatechartActionEnum.showErrors,
          ],
        },
      },
    },
    [FormPropertyShareStatechartStateEnum.sent]: {
      entry: [
        FormPropertyShareStatechartActionEnum.setSubmittedStatus,
        FormPropertyShareStatechartActionEnum.cacheModel,
      ],
    },
  },
};
